import httpCommon, { httpFormData } from "./http-common";

const getBusinessByPublicId = (publicId: string) => {
  return httpCommon.get(`/v1/get/business/${publicId}`);
};

// Get all businesses
const getAllBusinesses = (skip = 0) => {
  return httpCommon.get(`/v1/get/businesses?skip=${skip}`);
};

const getAllBusinessBankAccounts = (businessPublicId: string) => {
  return httpCommon.get(`/v1/get/businessBankAccounts/${businessPublicId}`);
};

// Get business count
const getAllBusinessesCount = () => {
  return httpCommon.get("/v1/get/count/businesses");
};

// Add business
const addBusiness = (data: any, onUploadProgress: (progressEvent: ProgressEvent) => void) => {
  return httpFormData.post("/v1/add/business", data, {
    onUploadProgress: (progressEvent: any) => onUploadProgress(progressEvent)
  });
};

const addBusinessBankAccount = (data: any) => {
  return httpCommon.post("/v1/add/businessBankAccount", data);
};

const getGoLiveRequest = (businessId: number) => {
  return httpCommon.get(`/v1/get/goLiveRequest/${businessId}`);
};

const addGoLiveRequest = (data: any) => {
  return httpCommon.post("/v1/add/goLiveRequest", data);
};

// Update specific business
const updateSpecificBusiness = (id: number, data: any, onUploadProgress: (progressEvent: ProgressEvent) => void) => {
  return httpFormData.put(`/v1/update/business/${id}`, data, {
    onUploadProgress: (progressEvent: any) => onUploadProgress(progressEvent)
  });
};

// Update self business
const updateBusiness = (data: any) => {
  return httpCommon.put(`/v1/update/business`, data);
};

// Delete business
const deleteBusiness = (id: number) => {
  return httpCommon.delete(`/v1/delete/business/${id}`);
};

const deleteBusinessBankAccount = (id: number) => {
  return httpCommon.delete(`/v1/delete/businessBankAccount/${id}`);
};

// Admin functions
const getBusinessAsAdminUser = () => {
  return httpCommon.get("/v1/admin/get/business");
};

const getAllBusinessesAsAdminUser = () => {
  return httpCommon.get("/v1/admin/get/businesses");
};

const getAllBusinessesCountAsAdminUser = () => {
  return httpCommon.get("/v1/admin/get/count/businesses");
};

const addBusinessAsAdminUser = (data: any) => {
  return httpCommon.post("/v1/admin/add/business", data);
};

const updateSpecificBusinessAsAdminUser = (id: number, data: any) => {
  return httpCommon.put(`/v1/admin/update/business/${id}`, data);
};

const updateBusinessAsAdminUser = (data: any) => {
  return httpCommon.put(`/v1/admin/update/business`, data);
};

const deleteBusinessAsAdminUser = (id: number) => {
  return httpCommon.delete(`/v1/admin/delete/business/${id}`);
};

const BusinessService = {
    getBusinessByPublicId,
    getAllBusinesses,
    getAllBusinessesCount,
    getAllBusinessBankAccounts,
    addBusiness,
    addBusinessBankAccount,
    getGoLiveRequest,
    addGoLiveRequest,
    updateSpecificBusiness,
    updateBusiness,
    deleteBusiness,
    getBusinessAsAdminUser,
    getAllBusinessesAsAdminUser,
    getAllBusinessesCountAsAdminUser,
    addBusinessAsAdminUser,
    updateSpecificBusinessAsAdminUser,
    updateBusinessAsAdminUser,
    deleteBusinessAsAdminUser,
    deleteBusinessBankAccount,
};
export default BusinessService;